import React from "react";


const Hero = () => (
  <div className="text-center hero my-5">
  </div>
);

export default Hero;
